import script from "./AidEditModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AidEditModal.vue?vue&type=script&setup=true&lang=ts"

import "./AidEditModal.vue?vue&type=style&index=0&id=6a754a3e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a754a3e"]])

export default __exports__